export const leaseAgreementDocumentCommand = {
  createDigitalSigningErrand: 'createDigitalSigningErrand',
  changeVisibilityLevel: 'changeVisibilityLevel',
};
